export default __webpack_public_path__ + "static/media/lenth.b7dc22ce.jpg";